import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createAddStockSlice = createAsyncThunk(
  "stockInventory/addStock",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/stockInventory/addStock", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAllStockSlice = createAsyncThunk(
  "stockInventory/getStock",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/stockInventory/getStock", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getStockByIdSlice = createAsyncThunk(
  "stockInventory/getIdbstock",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/stockInventory/getIdbstock", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const getLowStockSlice = createAsyncThunk(
  "stockInventory/getLowStock",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/stockInventory/getLowStock", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateStockSlice = createAsyncThunk(
  "stockInventory/updateStock",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/stockInventory/updateStock", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteStockSlice = createAsyncThunk(
  "stockInventory/deleteStock",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/stockInventory/deleteStock", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  stockInventory: [],
  stockInfo: [],
  lowStock: [],
  createStockSuccessMessage: null,
  createStockErrorMessage: null,
  updateStockSuccessMessage: null,
  updateStockErrorMessage: null,
  deleteStockSuccessMessage: null,
  deleteStockErrorMessage: null,
  lowStockSuccessMessage: null,
  searchStockErrorMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};

const stockInventorySlice = createSlice({
  name: "stock",
  initialState,
  reducers: {
    resetCreateStockMessage: (state) => {
      state.createStockSuccessMessage = null;
      state.createStockErrorMessage = null;
    },
    resetUpdateStockMessage: (state) => {
      state.updateStockSuccessMessage = null;
      state.updateStockErrorMessage = null;
    },
    resetDeleteStockMessage: (state) => {
      state.deleteStockSuccessMessage = null;
      state.deleteStockErrorMessage = null;
    },
    resetSearchStockMessage: (state) => {
      state.searchStockErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAddStockSlice.pending, (state) => {
        state.loading = true;
        state.createStockSuccessMessage = null;
        state.createStockErrorMessage = null;
      })
      .addCase(createAddStockSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.createStockErrorMessage = action?.payload?.result?.message;
        } else {
          state.createStockSuccessMessage = action?.payload?.result?.message;
        }
      })
      .addCase(createAddStockSlice.rejected, (state, action) => {
        state.loading = false;
        state.createStockErrorMessage = action?.payload?.result?.message;
      })
      .addCase(getAllStockSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllStockSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload.success) {
          state.stockInventory = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.searchStockErrorMessage =
            action.payload.result?.message || "No data found";
          return;
        }
        const result = action.payload.result;
        state.stockInventory = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchStockErrorMessage = null;
      })
      .addCase(getAllStockSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchStockErrorMessage = action?.payload?.result?.message;
      })
      .addCase(getLowStockSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLowStockSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchStockErrorMessage = action?.payload?.result?.message;
        }
        state.lowStock = action?.payload?.result?.list;
      })
      .addCase(getLowStockSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchStockErrorMessage = action?.payload?.result?.message;
      })
      .addCase(getStockByIdSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStockByIdSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.stockInfo = action?.payload?.result?.list;
      })
      .addCase(getStockByIdSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchStockErrorMessage = action?.payload?.result?.message;
      })
      .addCase(updateStockSlice.pending, (state) => {
        state.loading = true;
        state.updateStockSuccessMessage = null;
        state.updateStockErrorMessage = null;
      })
      .addCase(updateStockSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateStockErrorMessage = action?.payload?.result?.message;
        } else {
          state.updateStockSuccessMessage = action?.payload?.result?.message;
        }
      })
      .addCase(updateStockSlice.rejected, (state, action) => {
        state.loading = false;
        state.updateStockErrorMessage = action?.payload?.result?.message;
      })
      .addCase(deleteStockSlice.pending, (state) => {
        state.loading = true;
        state.deleteStockSuccessMessage = null;
        state.deleteStockErrorMessage = null;
      })
      .addCase(deleteStockSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deleteStockErrorMessage = action?.payload?.result?.message;
        } else {
          state.deleteStockSuccessMessage = action?.payload?.result?.message;
        }
      })
      .addCase(deleteStockSlice.rejected, (state, action) => {
        state.loading = false;
        state.deleteStockErrorMessage = action?.payload?.result?.message;
      });
  },
});

export const {
  resetCreateStockMessage,
  resetUpdateStockMessage,
  resetDeleteStockMessage,
  resetSearchStockMessage,
} = stockInventorySlice.actions;

export default stockInventorySlice.reducer;
